import React from "react";

export default function Rating({ filled, width, light }) {
  return (
    <svg
      viewBox="0 0 28 26"
      xmlns="http://www.w3.org/2000/svg"
      className={`${width ? width : "w-3 md:w-7"}`}
    >
      <path
        d="M21.7206 25.7348C21.4979 25.7357 21.2782 25.6854 21.08 25.5881L13.9778 22.0281L6.87559 25.5881C6.64497 25.7043 6.38495 25.7561 6.12509 25.7377C5.86524 25.7194 5.61596 25.6316 5.40561 25.4844C5.19526 25.3372 5.03228 25.1364 4.93518 24.9049C4.83808 24.6734 4.81076 24.4204 4.85633 24.1748L6.24893 16.6681L0.511446 11.3348C0.332439 11.1638 0.205454 10.9493 0.144118 10.7144C0.0827833 10.4795 0.0894135 10.233 0.163298 10.0015C0.244012 9.76451 0.392485 9.55395 0.591868 9.39369C0.791251 9.23343 1.03356 9.12988 1.2913 9.09481L9.22908 7.98814L12.7245 1.14814C12.8385 0.922715 13.0166 0.732599 13.2382 0.599574C13.4599 0.46655 13.7162 0.395996 13.9778 0.395996C14.2394 0.395996 14.4957 0.46655 14.7174 0.599574C14.9391 0.732599 15.1171 0.922715 15.2311 1.14814L18.7683 7.97481L26.7061 9.08148C26.9639 9.11655 27.2062 9.22009 27.4055 9.38035C27.6049 9.54061 27.7534 9.75117 27.8341 9.98814C27.908 10.2197 27.9146 10.4662 27.8533 10.7011C27.792 10.936 27.665 11.1504 27.486 11.3215L21.7485 16.6548L23.1411 24.1615C23.1908 24.4114 23.1648 24.6698 23.0661 24.9061C22.9674 25.1423 22.8001 25.3466 22.584 25.4948C22.3319 25.664 22.0282 25.7484 21.7206 25.7348V25.7348Z"
        className={
          filled
            ? "fill-primaryColor"
            : light
            ? "fill-whiteMid"
            : "fill-navyMid"
        }
      />
    </svg>
  );
}
